import assetsList from '@exodus/avalanchec-meta'
import { createAssetFactory } from '@exodus/ethereum-api'

const createAsset = createAssetFactory({
  assetsList,
  feeDataConfig: {
    // https://snowtrace.io/chart/gasprice
    // https://stats.avax.network/dashboard/c-chain-activity/
    gasPrice: '225 nAVAX',
    baseFeePerGas: '100 nAVAX',
    max: '1000 nAVAX',
    min: '25 nAVAX',
    fuelThreshold: '20000 nAVAX',
    eip1559Enabled: true,
    tipGasPrice: '4 nAVAX',
  },
  nfts: true,
  serverUrl: 'https://avax-c.a.exodus.io/wallet/v1/',
  confirmationsNumber: 30,
})

const assetPlugin = { createAsset }

export default assetPlugin
